import React from 'react';
import { styled } from 'styled-components';
import InlineMessage from '@ingka/inline-message';
import { useTranslation } from 'react-i18next';

export interface ServiceValidations {
  [key: string]: boolean;
}

interface ServiceValidationMsgProps {
  errors: ServiceValidations;
}
// eslint-disable-next-line
const StyledInlineMessage = styled(InlineMessage as any)`
  box-sizing: border-box;
  max-width: 670px;
  margin-bottom: 1rem;
`;

const StyledListItem = styled.li`
  margin: 0.25rem 0;
`;

const ServiceValidationMsg: React.FC<ServiceValidationMsgProps> = ({
  errors,
}) => {
  const { t } = useTranslation();

  if (!Object.values(errors).some(Boolean)) {
    return null;
  }

  const errorItems = Object.keys(errors)
    .filter((field): boolean => errors[field])
    .map((fieldKey): React.ReactNode => {
      const str = `${t(`pages.contact.${fieldKey}`)}:
          ${t(`pages.contact.validationErrors.${fieldKey}`)}`;
      return <StyledListItem key={fieldKey}>{str}</StyledListItem>;
    });

  return (
    <StyledInlineMessage
      variant="cautionary"
      title={t('pages.contact.validationErrors.errorTitle')}
      body={errorItems}
    />
  );
};

export default ServiceValidationMsg;
